import CubicBezier from './cubicBezier';
import WebAnimation from './WebAnimation';


function Tween(obj, options) {
    
    options  = options || {}
    
    if (typeof options.to === void 0) {
        throw('cannot create a tween witout values', obj)
    }

    let startValues = {}
    
    for (let k in options.to) {
        startValues[k] = obj[k];
    }

    let t = new WebAnimation({
        step: (e)=>{
            for (let k in options.to) {
                obj[k] = startValues[k] + (options.to[k]-startValues[k]) * e
            }
            options.step && options.step()
        },
        end:        options.onComplete,
        delay:      options.delay    * 1000,
        duration:   options.duration * 1000,
        easing:     options.easing
    });

    t.play();

    return t;


}


export default Tween
